<template>
	<div class="v-pagination-pager">
		<div class="v-pagination-pager-prev" @click="prev">
			<slot name="prev" v-if="'prev' in $slots"/>
			<v-icon type="v-icon-pager-prev" v-else/>
		</div>
		<div class="v-pagination-pager-btn" :class="{active:$parent.page.index==i}" v-for="i in buttons" :key="i" @click="go(i)">
			<slot v-if="'default' in $scopedSlots" :index="i"/>
			<span v-else>{{i}}</span>
		</div>
		<div class="v-pagination-pager-next" @click="next">
			<slot name="next" v-if="'next' in $slots"/>
			<v-icon type="v-icon-pager-next" v-else/>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    maxLength: {
      default: 10
    }
  },
  data() {
    return {
      buttons: []
    };
  },
  methods: {
    change() {
      let { index, count } = this.$parent.page,
        maxLength = this.maxLength - 1,
        start = 1,
        end = 10;
      start = Math.max(1, index - Math.floor(maxLength / 2));
      end = Math.min(start + maxLength, count);
      let surplus = maxLength - end + start;
      if (surplus) start = Math.max(1, start - surplus);
      this.buttons.length = 0;
      for (var i = start; i <= end; i++) this.buttons.push(i);
    },
    go(i) {
      let index = Math.max(Math.min(i, this.$parent.page.count), 1);
      this.$emit("change", Object.assign(this.$parent.page, { index }));
      this.change();
    },
    prev() {
      this.go(this.$parent.page.index - 1);
    },
    next() {
      this.go(this.$parent.page.index + 1);
    }
  },
  created() {
    this.change();
  }
};
</script>

<style lang="less">
.v-pagination-pager {
  display: flex;
  > div {
    cursor: pointer;
    font-size: 16px;
    padding: 2px 6px;
    line-height: 16px;
    &.v-pagination-pager-btn {
      &.active {
        color: #41b883;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/pagination/pager.vue